module.exports = __webpack_public_path__ + "img/ioxhost.d0bca2ef.svg";